<template>
  <div
    class="mobile-logo-area d-lg-none d-flex justify-content-between align-items-center visible-xs"
  >
    <div class="mobile-logo-wrap">
      <a href="index.html">
        <img alt="海南华德科技有限公司" src="@/assets/img/logo_white.png" style="width: 130px" />
      </a>
    </div>
    <div class="menu-close-btn" @click="$emit('close')">
      <i class="bi bi-x-lg text-white"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileMenuHeader",
};
</script>
<style scoped>
@import url("../../assets/css/animate.css");
@import url("../../assets/css/all.css");
@import url("../../assets/css/bootstrap.min.css");
@import url("../../assets/css/boxicons.min.css");
@import url("../../assets/css/bootstrap-icons.css");
@import url("../../assets/css/swiper-bundle.css");
@import url("../../assets/css/nice-select.css");
@import url("../../assets/css/magnific-popup.css");
@import url("../../assets/css/style.css");
</style>



// WEBPACK FOOTER //
// src/components/components/MobileMenuHeader.vue